import { useMutation, useQueryClient } from '@tanstack/react-query';
import { graphql } from '../gql/gql';
import { useAuth0 } from '../auth/AuthProvider';
import { graphqlRequest } from '../utils/graphqlClient';
import { DeleteTripMutation } from '../gql/graphql';

const deleteTripMutation = graphql(/* GraphQL */ `
  mutation deleteTrip($tripId: Int!) {
    deleteTrip(tripId: $tripId) {
      success
      message
      errorCode
    }
  }
`);

export const useDeleteTrip = () => {
  const { getAccessTokenSilently, isAuthenticated } = useAuth0();
  const queryClient = useQueryClient();

  return useMutation<DeleteTripMutation, Error, number>({
    mutationFn: async (tripId: number) => {
      if (!isAuthenticated) {
        throw new Error('User must be authenticated to delete a trip');
      }
      return graphqlRequest<DeleteTripMutation>(
        deleteTripMutation,
        { tripId },
        getAccessTokenSilently,
      );
    },
    onSuccess: () => {
      // Invalidate queries to refresh the trips list
      queryClient.invalidateQueries({ queryKey: ['partnerTrips'] });
      queryClient.invalidateQueries({ queryKey: ['trips'] });
    },
  });
};

export default useDeleteTrip;
